module.exports = __webpack_public_path__ + "static/img/LY.4318762c.svg";